<div class="support-section w-full">
  <h4 class="support-section_heading">Support</h4>
  <div
    *ngFor="let link of links"
    class="support-section_item w-full flex space-between items-center"
    (click)="window.open(link.link, '_blank')"
    (keydown.enter)="window.open(link.link, '_blank')"
    tabindex="0"
  >
    <p class="support-section_item__name">{{ link.name }}</p>
    <stxt-svg-icon class="support-section_arrow-svg" [iconConfig]="arrowSvgConfig"></stxt-svg-icon>
  </div>
  <div class="support-section_item w-full flex items-center">
    <p
      class="support-section_item__name pointer"
      (click)="logOut()"
      (keydown.enter)="logOut()"
      tabindex="0"
    >
      Log out
    </p>
  </div>
</div>
